import React from 'react'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function BasicText({ data }) {
  const { buttonLink, textBackgroundColor, textButtonExternalLink, textButtonText, textSubtitle, textText, textTitle } = data
  const buttonClass = (textBackgroundColor === 'deep-blue' || textBackgroundColor === 'aqua-blue') ? 'btn white-btn' : 'btn blue-btn';
  return (
    <section className='mycomponent-2'>
      <div className={`mycontent-wrap-2 ${textBackgroundColor}`}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 text-center'>
              <div className='mycontentcenter'>
                {textTitle && <h2 className='heading-level-2 blue-color'>{textTitle}</h2>}
                {textSubtitle && <p><strong>{textSubtitle}</strong></p>}
                {textText && parser(textText)}
                {textButtonExternalLink ? (
                  <a href={textButtonExternalLink} className={buttonClass}>{textButtonText}</a>
                ) : (
                  buttonLink && <Link to={buttonLink.uri} className={buttonClass}>{textButtonText}</Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
